import {useContext, useReducer} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import Context from "./Context/context";
import Reducer from "./Reducer/reducer";

function Index() {
  const globalState = useContext(Context);
  const [state, dispatch] = useReducer(Reducer, globalState);
console.log({state})
  return (
    <Context.Provider value={{ state, dispatch }}>
    <App />
    </Context.Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
      <Index />
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
